import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/ic3_cover.webp")